import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Select,
  Text,
  VStack,
} from "@chakra-ui/react";
import { FaArrowLeft, FaSave } from "react-icons/fa";
import { componentState } from "../../../../atoms/componentState";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useSetRecoilState } from "recoil";
import { LISTAGEMPLANOS } from "../../../../constants/paths";
import { ChangeEvent, useState } from "react";
import { NumericFormat } from "react-number-format";
import ClientFilterSelect from "../../../../defaultComponents/ClientFilterSelect";
import { toast } from "react-toastify";
import VendasRecorrentesApi from "../../../../services/vendasRecorrentesApi";
import { JWTToken } from "../../listaDeVendas/SalesList";
import jwt_decode from "jwt-decode";
import { customColors } from "../../../../atoms/customColors";

interface IFormInputs {
  frequencia: number;
  intervalo: number;
  valor: Number;
  taxa: Number;
  descricao: String;
  nome: String;
  duracao: Number;
}

export default function AddPlanosRecorrencia() {
  const setHeaderLocation = useSetRecoilState(componentState);
  setHeaderLocation("Cadastrar Planos de Recorrência");
  const navigate = useNavigate();

  const colors = useRecoilState(customColors)[0];

  const initialValues = {
    clientFilter: 0,
  };

  const token = window.localStorage.getItem("token");

  let jwtToken: JWTToken = jwt_decode(token || "");
  const idCliente = Number(jwtToken.idCliente);

  const [filtros, setFiltros] = useState(initialValues);

  const initialState = {
    frequencia: 1,
    intervalo: 0,
    valor: 0,
    taxa: 0,
    descricao: "",
    nome: "",
    duracao: 0,
  };

  const [planoRecorrencia, setPlanoRecorrencia] =
    useState<IFormInputs>(initialState);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setPlanoRecorrencia({
      ...planoRecorrencia,
      frequencia: Number(e.target.value),
    });
  };

  const handleDurationChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPlanoRecorrencia({
      ...planoRecorrencia,
      duracao: Number(e.target.value),
    });
  };

  const getFrequenciaLabel = (frequencia: number): string => {
    switch (frequencia) {
      case 1:
        return "Dias";
      case 2:
        return "Meses";
      case 3:
        return "Semanas";
      case 4:
        return "Anos";
      default:
        return "";
    }
  };
  const getLegenda = () => {
    const { frequencia, duracao, intervalo } = planoRecorrencia;
    let intervaloMensagem = "";

    if (intervalo > 0) {
      switch (frequencia) {
        case 1:
          intervaloMensagem = intervalo === 1 ? "1 dia" : `${intervalo} `;
          break;
        case 3:
          intervaloMensagem = intervalo === 1 ? "1 semana" : `${intervalo} `;
          break;
        case 2:
          intervaloMensagem = intervalo === 1 ? "1 mês" : `${intervalo} `;
          break;
        case 4:
          intervaloMensagem = intervalo === 1 ? "1 ano" : `${intervalo} `;
          break;
        default:
          intervaloMensagem = "";
      }
    }

    const frequenciaLabel: string = getFrequenciaLabel(frequencia);

    let legenda = `Este plano será cobrado de ${intervaloMensagem} em ${intervaloMensagem} ${frequenciaLabel}, com duração de ${duracao} ${frequenciaLabel}.`;

    return legenda;
  };

  function OnChangeValueInput(e: any, field: string) {
    setPlanoRecorrencia({
      ...planoRecorrencia,
      [field]: Number(e.slice(3).replace(",", ".")),
    });
  }

  function onSubmit() {
    const objForApi = {
      frequencia: planoRecorrencia.frequencia,
      intervalo: planoRecorrencia.intervalo,
      valor: Math.round(Number(planoRecorrencia.valor) * 100),
      taxa: Math.round(Number(planoRecorrencia.taxa) * 100),
      descricao: planoRecorrencia.descricao,
      nome: planoRecorrencia.nome,
      duracao: planoRecorrencia.duracao,
    };

    // console.log(objForApi);
    postPlanosRecorrencia(objForApi);
  }

  async function postPlanosRecorrencia(obj: any) {
    try {
      await VendasRecorrentesApi.postPlanoRecorrencia(obj, idCliente);
      toast.success("Plano de Recorrência cadastrado com sucesso!");
      navigate(LISTAGEMPLANOS);
    } catch (error) {
      toast.error("Não foi possível cadastrar o Plano de Recorrência!");
      console.log(error);
    }
  }

  return (
    <Flex flexDir={"column"} height="100%" width="100%">
      <Box
        width={"99.8%"}
        bgColor={colors.WHITE}
        height={"fit-content"}
        shadow={"md"}
        mt={"0.2%"}
        mx="auto"
        py={3}
        px={3}
      >
        <Flex
          justifyContent={"flex-end"}
          flexDirection={"row"}
          my={"auto"}
          px={8}
        >
          <Button
            leftIcon={<FaArrowLeft />}
            style={{ color: "white" }}
            onClick={() => {
              navigate(LISTAGEMPLANOS);
            }}
            _hover={{ bg: "#4B4B57" }}
            bgColor={colors.GRAY}
          >
            Voltar a Lista de Planos
          </Button>
          <Button
            leftIcon={<FaSave />}
            mx={3}
            style={{ color: "white" }}
            isDisabled={
              planoRecorrencia.nome !== "" &&
              planoRecorrencia.descricao !== "" &&
              planoRecorrencia.intervalo !== 0 &&
              planoRecorrencia.frequencia !== 0 &&
              planoRecorrencia.duracao !== 0 &&
              planoRecorrencia.valor !== 0
                ? // planoRecorrencia.taxa !== 0
                  false
                : true
            }
            onClick={() => {
              onSubmit();
            }}
            _hover={{ bg: "#4B4B57" }}
            bgColor={colors.BLUEMONEDDBUTTONS}
          >
            Salvar Plano
          </Button>
        </Flex>
      </Box>
      <Flex>
        <Box
          w={"30%"}
          height={"80vh"}
          bgColor={colors.WHITE}
          mt={"0.5%"}
          shadow={"md"}
          mx="auto"
          py={3}
          px={3}
          overflow={"auto"}
        >
          <VStack align="start" spacing={2}>
            <Text fontWeight="bold">Nome do Plano</Text>
            <Text>
              Neste campo, você definirá o nome do seu Plano
              <br />
              ex: Plano anual de seguro de vida
            </Text>

            <Text fontWeight="bold">Descrição</Text>
            <Text>
              Neste campo, você pode colocar uma descrição para o plano
              <br />
              ex: Plano anual
            </Text>

            <Text fontWeight="bold">Frequência Cobrada</Text>
            <Text>
              Aqui você seleciona a frequência deste plano, (diário, semanal,
              mensal ou anual)
            </Text>

            <Text fontWeight="bold">Duração do plano</Text>
            <Text>
              Neste campo, você indicará a duração do plano de acordo com a
              frequência escolhida anteriormente.
              <br />
              ex: Se a Frequência selecionada foi SEMANAL, na duração será
              indicado o número de semanas que este plano durará.
            </Text>

            <Text fontWeight="bold">Intervalo de cobrança</Text>
            <Text>
              Aqui é selecionado o intervalo de cobrança
              <br />
              ex: Se a Frequência selecionada foi SEMANAL, no intervalo será
              indicado de quantas em quantas semanas será realizada a cobrança.
            </Text>

            <Text fontWeight="bold">Taxa de adesão ao plano</Text>
            <Text>
              Esta taxa será cobrada APENAS na PRIMEIRA fatura. É uma taxa de
              adesão. Pode ser R$ 0,00.
            </Text>
          </VStack>
        </Box>
        <Box
          w={"65%"}
          height={"80vh"}
          bgColor={colors.WHITE}
          mt={"0.5%"}
          shadow={"md"}
          mx="auto"
          py={3}
          px={3}
          overflow={"auto"}
        >
          <Flex
            w={"100%"}
            height={"100%"}
            // bgColor={"red"}
            px={4}
            py={4}
            justifyContent={"space-evenly"}
          >
            <Flex w={"100%"} height={"100%"} flexDir={"column"}>
              <Flex w={"100%"}>
                {/* <FormControl p={2}>
                  <FormLabel>Cliente</FormLabel>
                  <Box w={"50"}>
                    <ClientFilterSelect
                      filtros={filtros}
                      setFiltros={setFiltros}
                    />
                  </Box>
                </FormControl> */}
                <FormControl p={2}>
                  <FormLabel>Nome do Plano</FormLabel>
                  <Input
                    placeholder="Nome do Plano"
                    type="text"
                    value={planoRecorrencia.nome.toString()}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                      setPlanoRecorrencia({
                        ...planoRecorrencia,
                        nome: e.target.value,
                      });
                    }}
                  />
                </FormControl>
              </Flex>
              <Flex w={"100%"}>
                <FormControl p={2}>
                  <FormLabel>Descrição</FormLabel>
                  <Input
                    placeholder="Descrição"
                    value={planoRecorrencia.descricao.toString()}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                      const value = e.target.value;
                      if (value.length <= 30) {
                        setPlanoRecorrencia({
                          ...planoRecorrencia,
                          descricao: value,
                        });
                      }
                    }}
                  />
                  {planoRecorrencia.descricao.length === 30 && (
                    <Text color="red.500" fontSize="sm" mt={1}>
                      Você atingiu o limite de 30 caracteres.
                    </Text>
                  )}
                </FormControl>
              </Flex>

              <Flex direction="column" w={"100%"}>
                <Flex w={"100%"}>
                  <FormControl p={2} isRequired>
                    <FormLabel>Frequência de Cobrança</FormLabel>
                    <Select
                      placeholder="Frequência de Cobrança"
                      value={Number(planoRecorrencia.frequencia)}
                      onChange={handleChange}
                    >
                      <option value={1}>Diário</option>
                      <option value={3}>Semanal</option>
                      <option value={2}>Mensal</option>
                      <option value={4}>Anual</option>
                    </Select>
                  </FormControl>
                  <FormControl p={2} isRequired>
                    <FormLabel>
                      Duração do Plano (de acordo com a frequência)
                    </FormLabel>
                    <Input
                      placeholder="Duração do Plano"
                      type="number"
                      value={Number(planoRecorrencia.duracao)}
                      onChange={handleDurationChange}
                    />
                  </FormControl>
                </Flex>
                <Flex w={"100%"}>
                  <FormControl p={2} isRequired>
                    <FormLabel>
                      Intervalo de Cobrança (de acordo com a frequência)
                    </FormLabel>
                    <Input
                      placeholder="Intervalo de Cobrança"
                      type="number"
                      value={Number(planoRecorrencia.intervalo)}
                      onChange={(e: ChangeEvent<HTMLInputElement>) => {
                        setPlanoRecorrencia({
                          ...planoRecorrencia,
                          intervalo: Number(e.target.value),
                        });
                      }}
                    />
                  </FormControl>
                </Flex>

                <Text mt={4} fontWeight="bold" color="red.500">
                  {getLegenda()}
                </Text>
              </Flex>
              <Flex w={"100%"}>
                <FormControl p={2} isRequired>
                  <FormLabel>
                    Taxa de adesão ao plano (cobrança na primeira fatura)
                  </FormLabel>
                  <NumericFormat
                    decimalScale={2}
                    prefix="R$ "
                    value={Number(planoRecorrencia.taxa)}
                    decimalSeparator=","
                    customInput={Input}
                    type="text"
                    placeholder="R$ 0,00"
                    onChange={(e: any) => {
                      OnChangeValueInput(e.target.value, "taxa");
                    }}
                  />
                </FormControl>
                <FormControl p={2} isRequired>
                  <FormLabel>Valor do Plano</FormLabel>
                  <NumericFormat
                    decimalScale={2}
                    prefix="R$ "
                    value={Number(planoRecorrencia.valor)}
                    decimalSeparator=","
                    customInput={Input}
                    type="text"
                    placeholder="R$ 0,00"
                    onChange={(e: any) => {
                      OnChangeValueInput(e.target.value, "valor");
                    }}
                  />
                </FormControl>
              </Flex>
            </Flex>
          </Flex>
        </Box>
      </Flex>
    </Flex>
  );
}
